import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CollectorEventBucket, DayState, Segment } from '../availability.model';
import {
  MAX_TOTAL_MINUTES,
  formatDateLabel,
  formatTime,
  totalMinutes
} from '../day-timeline.utils';

@Component({
  selector: 'app-day-card',
  templateUrl: './day-card.component.html',
  styleUrls: ['./day-card.component.css']
})
export class DayCardComponent {
  @Input() day!: DayState;
  @Input() events: CollectorEventBucket[] = [];
  @Output() dayChange = new EventEmitter<Partial<DayState>>();

  readonly formatDateLabel = formatDateLabel;
  readonly formatTime = formatTime;
  readonly maxTotalMinutes = MAX_TOTAL_MINUTES;

  get totalMinutes(): number {
    return totalMinutes(this.day.segments);
  }

  get overLimit(): boolean {
    return this.totalMinutes > this.maxTotalMinutes;
  }

  onSegmentsChange(segments: Segment[]): void {
    this.dayChange.emit({ segments });
  }

  onDayOffChange(checked: boolean): void {
    if (checked) {
      this.dayChange.emit({ dayOff: true, segments: [] });
    } else {
      this.dayChange.emit({ dayOff: false });
    }
  }

  trackBySegmentId(_: number, seg: Segment): string {
    return seg.id;
  }
}
